export const compareProductDisplayOrders = (productA, productB) => {
  // displayOrder が両方にある場合はそれで比較
  const orderA = productA.displayOrder ?? Infinity;
  const orderB = productB.displayOrder ?? Infinity;
  if (orderA !== orderB) return orderA - orderB;

  // displayOrder が同じ場合は従来のフィールドで比較
  const sortItems = [
    // 'supplyCommodityOwnerCd',
    'productDivisionId',
    'productClassLId',
    'productClassMId',
    'productClassSId',
    'productId',
    'originId',
    'rankId',
    'productClassId',
    'packingId',
    'weight',
    'weightUnitId'
  ];

  for (const item of sortItems) {

    if (productA[item] && (!productB[item] || productA[item] < productB[item])) {
      return -1
    }
    if (productB[item] && (!productA[item] || productA[item] > productB[item])) {
      return 1
    }
  }
  return 0;
}
